import {useState, useEffect} from "react";
import i18n from "core/i18n";

const useCustomTranslation = (translations) => {
    const [currentTranslations, setCurrentTranslations] = useState(
        translations[i18n.language] || {}
    );
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

    useEffect(() => {
        // Actualiza las traducciones cada vez que cambia el idioma
        const updateTranslations = () => {
            const lang = i18n.language;
            setCurrentLanguage(lang);
            setCurrentTranslations(translations[lang] || {}); // Carga únicamente las traducciones para el idioma actual
        };

        // Ejecuta la primera vez
        updateTranslations();

        // Escucha cambios de idioma desde i18next
        i18n.on("languageChanged", updateTranslations);

        return () => {
            i18n.off("languageChanged", updateTranslations);
        };
    }, [translations]);

    // Devuelve las traducciones disponibles o la clave por defecto si no se encuentra
    const t = (key) => currentTranslations[key] || key;

    return {t, currentLanguage};
};

export default useCustomTranslation;
